// extracted by mini-css-extract-plugin
export default {"wrapper":"PublishDate_wrapper__qgDTT","text":"PublishDate_text__8TUkY"};